// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** LetsBank — COMPE 630 */
export const LetsBank = createBankIcon({
  name: "LetsBank",
  slug: "letsbank",
  compe: "630",
  color: "#0d0d0d",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#0d0d0d;fill-opacity:1\"\n     id=\"letsbank_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.4041,20.9131) scale(0.02327)\">\n    <path d=\"M 1725.88747337,1498.82087433 L 1725.88747337,1997.69711723 L 732.836906402,1997.69711723 l 0,498.876242904 L 2223.6298518,2496.57336013 l 0,-997.752485808 z\" style=\"fill:#ff7140\" />\n    <path d=\"M 1728.38438768,503.502578416 L 1230.64562797,503.502578416 l 0,997.742835898 l 497.738759716,0 z\" style=\"fill:#b2f44a\" />\n    <path d=\"M 235.14519,4.39786182129 L 235.14519,1498.59168895 L 732.881537238,1498.59168895 L 732.881537238,503.268568089 L 1230.61788448,503.268568089 L 1230.61788448,4.39786182129 Z\" style=\"fill:#ff85e8\" />\n  </g>",
});
